import React from "react";
import lazyLoad from "common/utils/lazyLoad";
import { SubscriptionStaffReviewContextState } from "./context";
import { StaffReviewCard } from "./StaffReviewCard";

export default lazyLoad(
  () => import(/* webpackChunkName: "SubscriptionStaffReviewPillar" */ "."),
  // This loader makes the page pop around less
  <SubscriptionStaffReviewContextState.Provider
    value={{
      data: undefined,
      loading: true,
      globalSubscriptionId: "",
      staffReviewCompleted: false,
      onStaffReviewCompleted: () => {
        // do nothing
      },
    }}
  >
    <StaffReviewCard prospectId={0} canStartStaffReview />
  </SubscriptionStaffReviewContextState.Provider>,
);
